"use client";
import Link from "next/link";
import { Calendar, ArrowRight } from "lucide-react";
import React, { useEffect, useState } from "react";
import { createLookupObject } from "@/helper/helper";
import { ICMS } from "../cms/cmsModel";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import Image from "next/image";

interface BlogProps {
  blogData: any[];
  cmsData: ICMS[];
}

export default function BlogClient({ blogData, cmsData }: BlogProps) {
  const [CMSData, setCMSData] = React.useState<any>({});
  useEffect(() => {
    if (cmsData && cmsData?.length > 0) {
      setCMSData(createLookupObject(cmsData, "Name"));
    }
  }, [cmsData]);

  const posts = [
    {
      slug: "sell-jewellery-on-meesho",
      title: "How to Sell Imitation Jewellery on Meesho in 2026",
      excerpt:
        "A complete guide for new resellers on listing, pricing, and shipping jewellery on Meesho.",
      category: "Seller Tips",
      date: "Mar 10, 2026",
      emoji: "💍",
    },
    {
      slug: "new-mangalsutra-collection",
      title: "New Mangalsutra Collection — Gold & AD Designs",
      excerpt:
        "We have launched 18 new Mangalsutra designs for the wedding season. Bridal styles available.",
      category: "New Arrivals",
      date: "Mar 05, 2026",
      emoji: "💛",
    },
    {
      slug: "prevent-tarnishing-guide",
      title: "How to Store Imitation Jewellery to Prevent Tarnishing",
      excerpt:
        "Simple tips to keep your jewellery stock looking new for longer — great advice for retailers.",
      category: "Care Guide",
      date: "Feb 28, 2026",
      emoji: "✨",
    },
    {
      slug: "amazon-wholesale-sourcing",
      title: "Why Amazon Sellers Are Choosing Wholesale Over Retail",
      excerpt:
        "Understand the margin difference and how to source better for your Amazon FBA store.",
      category: "Business",
      date: "Feb 20, 2026",
      emoji: "🛒",
    },
    {
      slug: "shipping-zones-delivery-times",
      title: "Understanding Our Shipping Zones and Delivery Times",
      excerpt:
        "A detailed breakdown of delivery timelines by state and which courier to expect for your area.",
      category: "Shipping",
      date: "Feb 14, 2026",
      emoji: "📦",
    },
  ];

  return (
    <>
      <main className="min-h-screen bg-black">
        <Navbar />

        {/* PAGE HERO */}
        {CMSData?.["Blog - Section 1 : Banner"] ? (
          <section
            className="banner-section border-b border-border-1 pt-24 pb-16 px-4 md:px-14 relative overflow-hidden"
            dangerouslySetInnerHTML={{
              __html: CMSData?.["Blog - Section 1 : Banner"]?.Template,
            }}
          />
        ) : (
          <section className="banner-section border-b border-border-1 pt-24 pb-16 px-4 md:px-14 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-96 h-96 bg-gold-core/10 rounded-full blur-3xl -mr-32 -mt-32 pointer-events-none" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-gold-core/10 rounded-full blur-3xl -ml-24 -mb-24 pointer-events-none" />

            <div className="relative z-10">
              <div className="flex items-center gap-3.5 text-[10px] font-bold tracking-[0.4em] uppercase text-gold-text mb-6 before:h-px before:w-12 before:bg-gold-dim">
                Blog & News
              </div>
              <h1 className="font-cormorant text-[clamp(40px,6vw,72px)] font-light text-text-1 leading-[1.05] mb-6">
                Jewellery{" "}
                <em className="italic gold-text-gradient">Insights</em>
              </h1>
              <p className="text-base text-text-2 font-light leading-relaxed max-w-xl opacity-80">
                Expert tips for retailers, exclusive new arrivals, jewelry care
                guides, and strategic wholesale selling advice from Nakman.
              </p>
            </div>
          </section>
        )}

        {/* FEATURED: Marketplace Tips */}
        {CMSData?.["Blog - Section 2 : Marketplace Strategy"] && (
          <section
            className="bg-black py-12 px-4 md:px-14"
            dangerouslySetInnerHTML={{
              __html:
                CMSData?.["Blog - Section 2 : Marketplace Strategy"]?.Template,
            }}
          />
        )}
        {/* <section className="bg-black py-12 px-4 md:px-14">
          <div className="max-w-7xl mx-auto">
            <div className="bg-black-2 border border-border-gold/30 p-8 md:p-12 relative overflow-hidden group">
              <div className="absolute top-0 right-0 w-64 h-64 bg-gold-core/5 rounded-full blur-3xl transition-transform group-hover:scale-110" />
              <div className="relative z-10 flex flex-col md:flex-row gap-8 items-center">
                <div className="flex-1 space-y-6">
                  <div className="inline-flex items-center gap-2 px-3 py-1 bg-gold-core/10 rounded-full border border-gold-dim/20">
                    <span className="w-1.5 h-1.5 bg-gold-core rounded-full animate-pulse" />
                    <span className="text-[10px] text-gold-core font-bold uppercase tracking-widest">
                      Marketplace Strategy
                    </span>
                  </div>
                  <h2 className="text-2xl md:text-3xl font-cormorant text-text-1 italic leading-tight">
                    "Consistent product photography and accurate weight
                    descriptions are the #1 way to reduce returns on platforms
                    like Meesho & Amazon."
                  </h2>
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-gold-pale flex items-center justify-center text-gold-core font-bold text-sm border border-gold-dim shadow-xl">
                      NK
                    </div>
                    <div className="space-y-0.5">
                      <div className="text-xs text-text-1 font-bold uppercase tracking-widest">
                        Manish bhai
                      </div>
                      <div className="text-[10px] text-text-3 uppercase tracking-[0.2em]">
                        Founder, NakMan
                      </div>
                    </div>
                  </div>
                </div>
                <div className="hidden lg:block w-px h-32 bg-border-1 mx-8" />
                <div className="w-full md:w-auto shrink-0 space-y-4">
                  <p className="text-[10px] text-text-3 uppercase tracking-widest font-bold">
                    Reseller Program
                  </p>
                  <p className="text-sm text-text-2 leading-relaxed max-w-[240px]">
                    Join our inner circle of successful sellers and grow your
                    business with curated collections.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* BLOG GRID */}
        <section className="py-20 px-4 md:px-14 bg-black border-t border-border-1">
          <div className="max-w-7xl mx-auto space-y-16">
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
              <div className="space-y-2">
                <div className="text-[10px] font-bold tracking-[0.4em] uppercase text-gold-core">
                  Latest Stories
                </div>
                <h2 className="font-cormorant text-4xl text-text-1">
                  From the <em className="italic gold-text-gradient">Studio</em>
                </h2>
              </div>
              <div className="h-px flex-1 bg-gradient-to-r from-border-1 to-transparent hidden md:block" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
              {blogData?.map((post: any) => (
                <Link
                  key={post?.BlogURL}
                  href={`/blog/${post?.BlogURL}`}
                  className="group"
                >
                  <div className="space-y-6">
                    {/* Image Container */}
                    <div className="aspect-[16/10] overflow-hidden bg-black-2 relative border border-border-1 group-hover:border-gold-dim/40 transition-all duration-700 shadow-sm">
                      <Image
                        src={post?.Image}
                        alt={post?.Title}
                        fill
                        className="object-cover group-hover:scale-105 transition-all duration-700"
                      />
                      <div className="absolute inset-0 bg-black/5 group-hover:bg-transparent transition-colors duration-700" />
                      <div className="absolute top-4 left-4">
                        <div className="px-3 py-1 bg-white/90 backdrop-blur-md border border-border-1 text-[9px] text-gold-core font-bold uppercase tracking-[0.2em] shadow-sm">
                          {post?.BlogDate || "Recent"}
                        </div>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="space-y-3">
                      <h3 className="text-xl font-cormorant text-text-1 group-hover:text-gold-core transition-colors duration-500 leading-snug font-bold">
                        {post?.Title}
                      </h3>
                      <p
                        className="text-sm text-text-3 leading-relaxed line-clamp-3 opacity-80"
                        dangerouslySetInnerHTML={{
                          __html: post?.ShortDescription,
                        }}
                      />
                      <div className="pt-4 flex items-center gap-3 text-[10px] text-gold-core font-bold tracking-[0.2em] uppercase overflow-hidden">
                        <span className="group-hover:translate-x-1 transition-transform duration-500">
                          Read Narrative
                        </span>
                        <span className="h-px w-8 bg-gold-dim group-hover:w-12 transition-all duration-500" />
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {(!blogData || blogData.length === 0) && (
              <div className="py-20 text-center space-y-6">
                <div className="text-gold-dim font-cormorant italic text-2xl">
                  The gallery is currently being curated...
                </div>
                <p className="text-[10px] text-text-3 uppercase tracking-widest max-w-xs mx-auto">
                  New insights and collections are coming soon. Check back
                  shortly.
                </p>
              </div>
            )}
          </div>
        </section>

        <div className="gold-divider" />
        <Footer />
      </main>
    </>
  );
}
